// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"GEupgK","animatedgradient":"oupBtf","icon":"QB6swB","iconAnimate":"G07I0K"};